import { tenantByDomain, tenantById } from "./tenantRegistry";
import type { PlatformTenant } from "./types";

const normalizeHostname = (hostname: string) =>
  hostname
    .trim()
    .toLowerCase()
    .replace(/^\[/u, "")
    .replace(/\]$/u, "")
    .replace(/\.$/u, "");

const isLocalDevelopmentHost = (hostname: string) =>
  hostname === "localhost" ||
  hostname.endsWith(".localhost") ||
  hostname === "127.0.0.1" ||
  hostname === "::1";

const tenantFromLocalSubdomain = (hostname: string) => {
  if (!hostname.endsWith(".localhost")) return undefined;
  return tenantById.get(hostname.slice(0, -".localhost".length));
};

export function resolveTenant(
  hostname: string,
  search = "",
): PlatformTenant | undefined {
  const normalized = normalizeHostname(hostname);

  if (isLocalDevelopmentHost(normalized)) {
    const requestedTenant = new URLSearchParams(search).get("tenant");
    if (requestedTenant) return tenantById.get(requestedTenant);
    return tenantFromLocalSubdomain(normalized) ?? tenantById.get("sailplot");
  }

  return tenantByDomain.get(normalized);
}
